import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import {withToggledPaymentMethod} from './billingSettings';

const BillingSettingsCard = ({settings, isSaving, onChange, onSave}) => {
    const dueDays = Number(settings.invoice_due_days);
    const dueDaysInvalid = !!settings.show_due_date && (
        settings.invoice_due_days === null
        || settings.invoice_due_days === ''
        || !Number.isInteger(dueDays)
        || dueDays < 1
        || dueDays > 365
    );

    const updateSetting = (name, value) => {
        onChange({...settings, [name]: value});
    };

    return (
        <div className="card mb-3">
            <div className="card-body">
                <h5 className="text-center">Billing Settings</h5>

                <div className="form-group mb-2">
                    <label htmlFor="invoice-issue-mode">Invoice Issue Mode</label>
                    <select
                        id="invoice-issue-mode"
                        className="form-control"
                        value={settings.invoice_issue_mode}
                        onChange={(event) => updateSetting('invoice_issue_mode', event.target.value)}
                    >
                        <option value="per_pickup">Pay upon receipt after each delivery</option>
                        <option value="semi_monthly">Semi-monthly: 15th and month end</option>
                        <option value="monthly">Monthly: month end</option>
                    </select>
                </div>

                <div className="form-check mb-2">
                    <input
                        id="show-invoice-due-date"
                        className="form-check-input"
                        type="checkbox"
                        checked={!!settings.show_due_date}
                        onChange={(event) => updateSetting('show_due_date', event.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="show-invoice-due-date">
                        Show due date on invoice
                    </label>
                </div>

                {settings.show_due_date && (
                    <div className="form-group mb-2">
                        <label htmlFor="invoice-due-days">Due Days</label>
                        <input
                            id="invoice-due-days"
                            type="number"
                            min="1"
                            max="365"
                            step="1"
                            required
                            className="form-control"
                            value={settings.invoice_due_days || ''}
                            onChange={(event) => updateSetting('invoice_due_days', event.target.value)}
                        />
                        {dueDaysInvalid && (
                            <small className="form-text text-danger">
                                Due Days must be between 1 and 365.
                            </small>
                        )}
                    </div>
                )}

                <div className="mb-2">
                    <span>Allowed Payment Methods</span>

                    <div className="form-check">
                        <input
                            id="allow-invoice-payment"
                            className="form-check-input"
                            type="checkbox"
                            checked={(settings.allowed_payment_methods || []).includes('invoice')}
                            onChange={() => onChange(withToggledPaymentMethod(settings, 'invoice'))}
                        />
                        <label className="form-check-label" htmlFor="allow-invoice-payment">
                            Invoice / Terms
                        </label>
                    </div>

                    <div className="form-check">
                        <input
                            id="allow-card-payment"
                            className="form-check-input"
                            type="checkbox"
                            checked={(settings.allowed_payment_methods || []).includes('card')}
                            onChange={() => onChange(withToggledPaymentMethod(settings, 'card'))}
                        />
                        <label className="form-check-label" htmlFor="allow-card-payment">
                            Credit Card
                        </label>
                    </div>
                </div>

                <div className="form-check mb-3">
                    <input
                        id="auto-invoice-enabled"
                        className="form-check-input"
                        type="checkbox"
                        checked={!!settings.is_auto_invoice_enabled}
                        onChange={(event) => updateSetting('is_auto_invoice_enabled', event.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="auto-invoice-enabled">
                        Auto invoice enabled
                    </label>
                </div>

                <div className="text-center">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onSave}
                        disabled={isSaving || dueDaysInvalid}
                    >
                        {isSaving ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                &nbsp;Saving...
                            </>
                        ) : 'Save Billing Settings'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BillingSettingsCard;
